/**
 * Skeleton Component
 *
 * Loading placeholder for content
 * - Multiple variants (text, circle, rectangle, card)
 * - Customizable dimensions
 * - Smooth animation
 */

import React from "react";
import PropTypes from "prop-types";
import "./Skeleton.scss";

export const Skeleton = ({
  variant = "text",
  width,
  height,
  count = 1,
  className = "",
}) => {
  const skeletonClasses = ["skeleton", `skeleton--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  const skeletonStyle = {
    width: width || undefined,
    height: height || undefined,
  };

  if (count === 1) {
    return <div className={skeletonClasses} style={skeletonStyle} />;
  }

  return (
    <div className="skeleton-group">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={skeletonClasses} style={skeletonStyle} />
      ))}
    </div>
  );
};

Skeleton.propTypes = {
  variant: PropTypes.oneOf(["text", "circle", "rectangle", "card"]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  count: PropTypes.number,
  className: PropTypes.string,
};

export default Skeleton;
